import { Controller } from 'stimulus'
import CheckoutController from './checkout_controller'

export type AccountForm = {
  first_name: string
  last_name: string
  email: string
  password: string
}

export default class FormAccountController extends Controller {
  declare firstNameTarget: HTMLInputElement
  declare lastNameTarget: HTMLInputElement
  declare emailTarget: HTMLInputElement
  declare passwordTarget: HTMLInputElement
  static targets = ['firstName', 'lastName', 'email', 'password']

  declare checkoutOutlet: CheckoutController
  static outlets = ['checkout']

  connect() {
    this.firstNameTarget.focus()
    this.setInitialValues()
    this.checkoutOutlet.onPage1()
  }

  setInitialValues() {
    if (!this.checkoutOutlet.accountForm) return
    const { first_name, last_name, email, password } =
      this.checkoutOutlet.accountForm

    this.firstNameTarget.value = first_name
    this.lastNameTarget.value = last_name
    this.emailTarget.value = email
    this.passwordTarget.value = password
  }

  submit(event: SubmitEvent) {
    if (!event.target) throw new Error('Missing event target')

    const formData = new FormData(event.target as HTMLFormElement)
    const accountForm: AccountForm = {
      first_name: formData.get('first_name') as string,
      last_name: formData.get('last_name') as string,
      email: formData.get('email') as string,
      password: formData.get('password') as string,
    }

    accountForm.email = accountForm.email.trim()
    this.checkoutOutlet.setAccountForm(accountForm)
  }
}
